// extracted by mini-css-extract-plugin
export default {"day":"_3Xxy2Pam","dayName":"gUgLzNof","dayNameScrolled":"mstVFPvR","dayNameText":"v3Y7qZbw","dayRows":"_3BdINv5i","currentDay":"_2c-H-dt6"};